// extracted by mini-css-extract-plugin
export default {"cls1":"VBGZVwlqsOeWUzaLjUzi","cls2":"C6zHjZA_Lv_iFQ1RKZS2 VBGZVwlqsOeWUzaLjUzi"};